export default __webpack_public_path__ + "static/video-img-c47fe08b2e34c50c7f26762f289cf216.png";